import { render, staticRenderFns } from "./FullBlockVideo.vue?vue&type=template&id=3d9cf058&scoped=true&"
import script from "./FullBlockVideo.vue?vue&type=script&lang=js&"
export * from "./FullBlockVideo.vue?vue&type=script&lang=js&"
import style0 from "./FullBlockVideo.vue?vue&type=style&index=0&id=3d9cf058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9cf058",
  null
  
)

export default component.exports